/* eslint-disable react-refresh/only-export-components */
import { FC, lazy, LazyExoticComponent } from 'react';

import { routingConfig } from '../../consts';
import { RouteWithComponent } from '../../interfaces';

const IndicatorsTabCommon: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/indicatorsTabCommon/indicatorsTabCommon.component')
);
const IndicatorsTabStrategic: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/indicatorsTabStrategic/indicatorsTabStrategic.component')
);
const Statistics: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/statistics/statistics.component')
);

export const teamIndicatorsRoutes: RouteWithComponent[] = [
  { pathSettings: routingConfig.teamIndicators.children.teamIndicatorsCommon, component: IndicatorsTabCommon },
  { pathSettings: routingConfig.teamIndicators.children.teamIndicatorsStrategic, component: IndicatorsTabStrategic },
  { pathSettings: routingConfig.teamIndicators.children.teamIndicatorsStatistics, component: Statistics },
];
